const STEPS = [
  { key: "brief", name: "Brief", line: "We understand the business, the owners and the objective." },
  { key: "route", name: "Route", line: "We recommend the jurisdiction and structure, and say what we do not yet know." },
  { key: "register", name: "Register", line: "We prepare and file with the relevant registry or authority." },
  { key: "maintain", name: "Maintain", line: "We keep the entity compliant after it is formed." },
];

// "How an incorporation runs" — horizontal line with four Gold nodes.
// No durations, no fees, no guarantees.
export const AtlasProcess = () => (
  <section data-testid="atlas-process" className="bg-canvas border-t border-charcoal/10">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 md:py-24">
      <h2 className="font-serif text-3xl md:text-4xl text-charcoal">How an incorporation runs</h2>
      <ol className="mt-14 relative grid grid-cols-1 md:grid-cols-4 gap-x-10 gap-y-10">
        {/* Connector line (desktop) */}
        <span aria-hidden="true" className="hidden md:block absolute top-[5px] left-0 right-0 h-px bg-gold/50" />
        {STEPS.map((s) => (
          <li key={s.key} data-testid={`process-step-${s.key}`} className="relative md:pt-8">
            {/* Node (desktop — sits on the connector line) */}
            <span aria-hidden="true" className="hidden md:block absolute top-0 left-0 w-[11px] h-[11px] rounded-full bg-gold border-2 border-canvas" />
            {/* Node (mobile — inline with the name) */}
            <span className="flex items-center gap-3 md:hidden">
              <span aria-hidden="true" className="w-[11px] h-[11px] rounded-full bg-gold shrink-0" />
              <span className="font-serif text-lg text-charcoal">{s.name}</span>
            </span>
            <h3 className="hidden md:block font-serif text-lg text-charcoal">{s.name}</h3>
            <p className="mt-2 md:mt-3 font-sans text-sm leading-relaxed text-charcoal/65">{s.line}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
